// @flow
import { createContext } from "react";
import { LocaleContextType } from "../types";
import { TposBasketContextType } from "../types/contexts";

const LocaleContext = createContext<LocaleContextType>({} as LocaleContextType);

const TposBasketContext = createContext<TposBasketContextType>(
  {} as TposBasketContextType,
);

export { LocaleContext, TposBasketContext };
